import instance from "./config";
import FileDownload from "js-file-download";

const eVoucherApi = {
  list: function (params = {}) {
    return instance.get("/api/evouchers", { params });
  },
  bulkCreate: function (payload) {
    return instance.post("/api/evouchers/bulk", payload);
  },
  exportByPrefix: async function (prefix = "") {
    const normalizedPrefix = prefix.trim().toUpperCase();
    const res = await instance.get("/api/evouchers/export", {
      params: { prefix: normalizedPrefix },
      responseType: "blob",
    });
    FileDownload(res, `EVOUCHER_${normalizedPrefix || "PREFIX"}.xlsx`);
  },
};

export default eVoucherApi;
